var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.44,
    height: 20.357,
    viewBox: "0 0 20.44 20.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-menu-5253352",
    transform: "translate(-79.033 -10.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9834",
    "data-name": "Path 9834",
    d: "M98.553,10.128H88.39a.92.92,0,0,0-.919.918v7.722a.919.919,0,0,0,.919.918H98.553a.92.92,0,0,0,.919-.918V11.046a.92.92,0,0,0-.919-.918Zm0,10.781H92.891a.92.92,0,0,0-.919.919v7.738a.92.92,0,0,0,.919.918h5.662a.92.92,0,0,0,.919-.918V21.827a.92.92,0,0,0-.919-.918Zm-8.437.018H79.95a.919.919,0,0,0-.917.918v7.722a.919.919,0,0,0,.917.918H90.116a.918.918,0,0,0,.917-.918V21.844a.918.918,0,0,0-.917-.918ZM79.95,19.686h5.665a.92.92,0,0,0,.919-.918V11.047a.919.919,0,0,0-.919-.919H79.95a.92.92,0,0,0-.917.918v7.722a.92.92,0,0,0,.917.919Z",
    fill: "#4EB6EE",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1111);
export default __webpack_public_path__ + "static/media/1111.faeafb786fd6e67cd6df41802e0cc198.svg";
export { ForwardRef as ReactComponent };